//Import external libraries
import React, { useEffect, useState } from "react";

import {
  Page,
  Text,
  View,
  Document,
  Image,
  BlobProvider,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

//Import internal resources and services
import FanChartReactPDF from "./fanChart/FanChartReactPDF";
import AboutProlux from "./Components/AboutProlux";
import GenProdSpec from "./Components/GenProdSpec";
import EuroventInfo from "./Components/EuroventInfo";
import HeatExchangerEha from "./Components/HeatExchangerEha";
import HeatExchangerSup from "./Components/HeatExchangerSup";
import Ecodesign from "./Components/Ecodesign";
import ProluxHeader from "./Components/ProluxHeader";
import ProluxFooter from "./Components/ProluxFooter";
import CompactFilter from "./Components/CompactFilter";
import PlugFan from "./Components/PlugFan";
import ConnectingSection from "./Components/ConnectingSection";
import CoilsSection from "./Components/CoilsSection";
import SoundLevels from "./Components/SoundLevels";
import DropSeparator from "./Components/DropSeparator";
import {
  getCalculations,
  getCalculationsByAdmin,
} from "../../utils/services/projectService";
import styles from "./TechCardStyles";
//import theme from "../../styles/TermoventTheme";

//Import MUI components
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useTheme } from "@mui/material/styles";

const TechCardContent = ({ id, techData, heatRecovery, tittle }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const today = new Date();
  const date =
    today.getDate() + "-" + (today.getMonth() + 1) + "-" + today.getFullYear();
  const dayNames = [
    t("daysOfWeek.sunday"),
    t("daysOfWeek.monday"),
    t("daysOfWeek.tuesday"),
    t("daysOfWeek.wednesday"),
    t("daysOfWeek.thursday"),
    t("daysOfWeek.friday"),
    t("daysOfWeek.saturday"),
  ];
  const day = today.getDay();

  return (
    <Document title={tittle} author="Prolux Climate Prime">
      <Page size="A4" style={styles.page}>
        <ProluxHeader styles={styles} />
        <View style={styles.section}>
          <AboutProlux styles={styles} techData={techData} date={date} />
          <GenProdSpec styles={styles} techData={techData} />
          <EuroventInfo
            styles={styles}
            techData={techData}
            heatRecovery={heatRecovery}
          />
          {/*  <View style={styles["img-center"]}>
            <Image
              src={
                heatRecovery === "Rotary heat exchanger" ||
                heatRecovery === "Rotacioni izmenjivač toplote"
                  ? KKCompactR05
                  : KKCompactP05
              }
              alt="test"
              style={{ width: "40%" }}
            />
            </View>*/}
          <View style={{ ...styles.heading, marginBottom: "15px" }} break>
            <Text style={styles.title}>
              {t("techCard.SupplySide").toUpperCase()}
            </Text>
          </View>
          <ConnectingSection
            title={t("techCard.ConnSec.Title")}
            data={
              techData.generalProductSpec.connectingSectionSupIn
                .flexibleConnection
            }
            styles={styles}
            airflow={
              techData.calculation.winterRecCalculation.sup_AirVolumeFlow
            }
            regDumper={
              techData.generalProductSpec.connectingSectionSupIn
                .regulationDamper
            }
          />
          <CompactFilter
            type={"supply"}
            data={techData.calculation.supplyFilterCalculation}
            styles={styles}
            airflow={
              techData.calculation.winterRecCalculation.sup_AirVolumeFlow
            }
            title={t("techCard.FilterSec.Title")}
          />
          <HeatExchangerSup
            styles={styles}
            techData={techData}
            heatRecovery={heatRecovery}
          />
          <PlugFan
            styles={styles}
            data={techData.calculation.supplyFanCalculation}
            airflow={
              techData.calculation.winterRecCalculation.sup_AirVolumeFlow
            }
            title={t("techCard.FanSection.Title")}
            coolingAirPressureDropDry={
              techData.calculation.cooling.airPressureDropDry
            }
            coolingAirPressureDropWet={
              techData.calculation.cooling.airPressureDropWet
            }
          />
          {techData.calculation.supplyFanCalculation.fanChart !== "" &&
            techData.calculation.supplyFanCalculation.fanChart !== "-" && (
              <View style={styles["img-center"]}>
                <FanChartReactPDF
                  type={techData.calculation.supplyFanCalculation.type}
                  chartFile={JSON.parse(
                    techData.calculation.supplyFanCalculation.fanChart
                  )}
                />
              </View>
            )}
          {techData.calculation.heating.capacity !== "" && (
            <CoilsSection
              styles={styles}
              tittle={t("techCard.CoilsSec.HeaterSection")}
              data={techData.calculation.heating}
              airflow={
                techData.calculation.winterRecCalculation.sup_AirVolumeFlow
              }
              // airTempIn={
              // techData.calculation.winterRecCalculation.sup_AirTempIn
              //}
              //airTempOut={
              // techData.calculation.winterRecCalculation.sup_AirTempOut
              // }
              // recuperatorTempOut={
              //  techData.calculation.winterRecCalculation.sup_AirTempOut
              //}
              recuperatorHumidityOut={
                techData.calculation.winterRecCalculation.sup_HumidityOut
              }
              humidityAfterRec={techData.calculation.heating.humidityAfterRec}
              disableBreak={true}
            />
          )}
          {techData.calculation.cooling.capacity !== "" && (
            <CoilsSection
              styles={styles}
              tittle={t("techCard.CoilsSec.CoolerSection")}
              data={techData.calculation.cooling}
              airflow={
                techData.calculation.summerRecCalculation.sup_AirVolumeFlow
              }
              airTempIn={
                techData.calculation.summerRecCalculation.sup_AirVolumeFlow
              }
              airTempOut={
                techData.calculation.summerRecCalculation.sup_AirTempOut
              }
              recuperatorTempOut={
                techData.calculation.summerRecCalculation.sup_AirTempOut
              }
              recuperatorHumidityOut={
                techData.calculation.summerRecCalculation.sup_HumidityOut
              }
              humidityAfterRec={techData.calculation.cooling.humidityAfterRec}
              pageBreak={
                techData.calculation.cooling.capacity !== "" &&
                techData.calculation.heating.capacity !== ""
              }
              cooling={true}
            />
          )}

          {techData.calculation.cooling.capacity !== "" && (
            <DropSeparator styles={styles} techData={techData} />
          )}
          <ConnectingSection
            styles={styles}
            title={t("techCard.ConnSec.Title2")}
            data={
              techData.generalProductSpec.connectingSectionSupOut
                .flexibleConnection
            }
            regDumper={
              techData.generalProductSpec.connectingSectionSupOut
                .regulationDamper
            }
          />
          <View style={{ ...styles.heading, marginBottom: "15px" }} break>
            <Text style={styles.title}>
              {t("techCard.ExhaustSide").toUpperCase()}
            </Text>
          </View>
          <ConnectingSection
            title={t("techCard.ConnSec.Title3")}
            data={
              techData.generalProductSpec.connectingSectionEhaIn
                .flexibleConnection
            }
            styles={styles}
            regDumper={
              techData.generalProductSpec.connectingSectionEhaIn
                .regulationDamper
            }
          />
          <CompactFilter
            styles={styles}
            type={"exhaust"}
            data={techData.calculation.exhaustFilterCalculation}
            airflow={
              techData.calculation.winterRecCalculation.eha_AirVolumeFlow
            }
            title={t("techCard.FilterSec.Title2")}
          />
          <HeatExchangerEha
            styles={styles}
            techData={techData}
            heatRecovery={heatRecovery}
            title={t("techCard.ConnSec.Title4")}
            type={"exhaust"}
          />
          <PlugFan
            styles={styles}
            data={techData.calculation.exhaustFanCalculation}
            airflow={
              techData.calculation.winterRecCalculation.eha_AirVolumeFlow
            }
            title={t("techCard.FanSection.Title2")}
          />
          {techData.calculation.exhaustFanCalculation.fanChart !== "" &&
            techData.calculation.exhaustFanCalculation.fanChart !== "-" && (
              <View style={styles["img-center"]}>
                <FanChartReactPDF
                  type={techData.calculation.exhaustFanCalculation.type}
                  chartFile={JSON.parse(
                    techData.calculation.exhaustFanCalculation.fanChart
                  )}
                />
              </View>
            )}
          <ConnectingSection
            title={t("techCard.ConnSec.Title4")}
            styles={styles}
            data={
              techData.generalProductSpec.connectingSectionEhaOut
                .flexibleConnection
            }
            regDumper={
              techData.generalProductSpec.connectingSectionEhaOut
                .regulationDamper
            }
            airflow={
              techData.calculation.winterRecCalculation.eha_AirVolumeFlow
            }
          />
          {/*   <View> style={{ transform: "translateY(-200px)" }} break>*/}
          <SoundLevels
            title={t("techCard.ConnSec.Title4")}
            styles={styles}
            supplyFanCalculation={techData.calculation.supplyFanCalculation}
            exhaustFanCalculation={techData.calculation.exhaustFanCalculation}
            toSurroundings={techData.calculation.noiseLevels}
            insulation={techData.generalProductSpec.insulation}
          />
          {/*</View>*/}
          <Ecodesign styles={styles} techData={techData} />
        </View>

        <ProluxFooter dayNames={dayNames} date={date} day={day} />
      </Page>
    </Document>
  );
};

const TechCardTermovent = React.memo(
  ({ id, revNum, heatRecovery, cardContent, admin }) => {
    const [techData, setTechData] = useState(cardContent);
    const { t } = useTranslation();

    const [docName, setDocName] = useState("TechnicalCard");
    const [show, setShow] = useState(true);
    const theme = useTheme();
    /* useEffect(() => {
      const timer = setTimeout(() => {
        setShow(false);
      }, 5000);

      return () => {
        clearTimeout(timer);
      };
    }, []);*/

    useEffect(() => {
      console.log(cardContent);
      if (cardContent != undefined)
        setDocName(
          docName +
            "_Project-" +
            cardContent.project +
            "_Position-" +
            cardContent.system +
            "_rev-" +
            cardContent.revision
        );
      if (
        cardContent == undefined &&
        id !== undefined &&
        revNum !== undefined
      ) {
        if (!admin) {
          getCalculations(id, revNum).then((res) => {
            setTechData(res.data.data);
            setDocName(
              docName +
                "_Project-" +
                res.data.data.project +
                "_Position-" +
                res.data.data.system +
                "_rev-" +
                res.data.data.revision
            );
          });
        } else {
          getCalculationsByAdmin(id, revNum).then((res) => {
            setTechData(res.data.data);
            setDocName(
              docName +
                "_Project-" +
                res.data.data.project +
                "_Position-" +
                res.data.data.system +
                "_rev-" +
                res.data.data.revision
            );
          });
        }
      } else return;
    }, [id, revNum]);

    if (
      techData == undefined ||
      // techData.generalProductSpec == undefined ||
      techData == null //||
      // techData.generalProductSpec == null
    )
      return null;

    console.log(techData);

    return (
      <BlobProvider
        document={
          <TechCardContent
            id={id}
            techData={techData}
            revNum={revNum}
            heatRecovery={heatRecovery}
            tittle={`${docName}.pdf`}
          />
        }
        fileName={`${docName}.pdf`}
      >
        {({ url, loading, error }) => {
          const blinkAnimation = {
            "@keyframes blink-animation": {
              "50%": {
                opacity: 0,
              },
            },
            animation: show
              ? "blink-animation 0.1s steps(2, start) infinite"
              : "none",
          };
          if (loading) {
            return (
              <span
                className={show ? "blink" : "stop"}
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: theme.palette.secondary.main,
                }}
              >
                <span>{t("techCard.GeneratePDF")}</span>
                <PictureAsPdfIcon
                  sx={{
                    color: show
                      ? theme.palette.secondary.main
                      : theme.palette.primary.main,
                    width: "26px",
                  }}
                />
              </span>
            );
          }
          if (!loading && url) {
            return (
              <a
                href={url}
                download={`${docName}.pdf`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none", // Uklanja underline
                  color: theme.palette.secondary.main,
                  gap: "4px",
                }}
              >
                <span>{t("techCard.DownloadPDF")}</span>
                <PictureAsPdfIcon
                  sx={{
                    color: show
                      ? theme.palette.secondary.main
                      : theme.palette.primary.main,
                    width: "26px",
                  }}
                />
              </a>
            );
          }
          if (error) {
            console.error(error);
            return <p>An error occurred</p>;
          }
          return null;
        }}
      </BlobProvider>
    );
  }
);

//TechCardTermovent.whyDidYouRender = true;

export default TechCardTermovent;

/* */

/*({ id, revNum, heatRecovery, docName }) => {
   
    return (
      <PDFDownloadLink
        document={
          <TechCardContent
            id={id}
            revNum={revNum}
            heatRecovery={heatRecovery}
          />
        }
        fileName={`${docName}.pdf`}
      >
        {({ blob, url, loading, error }) => {
          loading ? ( 
            <span></span>
          ) : (
            <Button>
              {" "}
              <PictureAsPdfIcon sx={{ color: "#343734", width: "26px" }} />
            </Button>
          );
        }}
      </PDFDownloadLink>
    );
  }
);*/
